// Modules
import { sign, verify } from "jsonwebtoken";

import { compareSync } from "bcryptjs";

export const JWT_ALGORITHM = "HS256";
const JWT_SECRET_KEY = process.env.NEXT_PUBLIC_SECRET_KEY;

/**
 * Generates a jwt toke valid for 60 seconds
 *
 * @returns the jwt token
 */
export function generateToken() {
    const token = sign({ app: process.env.NEXT_PUBLIC_APP_NAME }, JWT_SECRET_KEY, {
        expiresIn: 60000,
        algorithm: JWT_ALGORITHM
    });

    return token;
}

/**
 * Extracts the token from a complete token string (with 'Bearer ' as prefix).
 *
 * @param {String | undefined} bearerToken the jwt complete token (with 'Bearer ' as prefix) to be verified
 * @returns the token without the prefix
 */
export function extractToken(bearerToken: string | undefined) {
    if (!bearerToken || bearerToken.length < 8) {
        return null;
    }

    const token = bearerToken.slice(7);

    return token;
}

/**
 * Verifies a jwt token.
 *
 * @param {String} bearerToken the jwt complete token (with 'Bearer ' as prefix) to be verified
 * @returns true is it is valid, false otherwise
 */
export function verifyToken(bearerToken: string | undefined) {
    const token = extractToken(bearerToken);

    if (!token) {
        return null;
    }

    try {
        const decoded = verify(
            token,
            JWT_SECRET_KEY,
            {
                algorithms: [JWT_ALGORITHM]
            }
            // error => {
            //     return !error;
            // }
        );
        return decoded;
    } catch (error) {
        return null;
    }
}

/**
 * aValidates the token against the website hashed token.
 * Only for website integrations.
 *
 * @param {String} hashedToken the token hashed to validate
 * @returns true if it is valid, false otherwise
 */
export function isWebsiteTokenValid(hashedToken) {
    const token = `${process.env.NEXT_PUBLIC_WEBSITE_API_SECRET_KEY}_${new Date().toISOString().split("T")[0]}`;
    const isValid = token && hashedToken && compareSync(token, hashedToken);

    return isValid;
}
